import { useQuery } from '@tanstack/react-query';
import { marksService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import type { MarkToMarketItem } from '@/types';

/** GET /positions/{id}/marks/ — full MTM history for one position, newest-first. */
export const usePositionMarks = (positionId: number | null, enabled: boolean = true) => {
  return useQuery<MarkToMarketItem[]>({
    queryKey: queryKeys.trades.marks(positionId ?? 0),
    queryFn: () => marksService.getPositionMarks(positionId!),
    enabled: enabled && positionId != null,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
};
